import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { Person_Interface } from 'src/app/Interface/Person_Interface';
import { QUANTITY_Interface } from 'src/app/Interface/QUANTITY_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QUANTITYService {

  constructor(private http:HttpClient) { }

  GetRecord1(id:number):Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Quantity?id="+id).pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  GetTree():Observable<Array<QUANTITY_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Quantity/GetTree").pipe(
      map(data=>{
        return data as Array<QUANTITY_Interface>
      })
    )
  }

  GetActive():Observable<Array<QUANTITY_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Quantity/Getactive").pipe(
      map(data=>{
        return data as Array<QUANTITY_Interface>
      })
    )
  }

  GetActiveParent():Observable<Array<QUANTITY_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Quantity/Getactiveparent").pipe(
      map(data=>{
        return data as Array<QUANTITY_Interface>
      })
    )
  }


  EditAddQUANTITY(model: QUANTITY_Interface):Observable<QUANTITY_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      certificate_id:model.certificate_id,
      dataentity_id:model.dataentity_id,
      parent:model.parent,
      del:false,
      username:'',
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/Quantity/AddEdit",body,{headers}).pipe(
        map(data=>{
          return data as QUANTITY_Interface
        })
      )

  }

  DeleteQUANTITY(id:number):Observable<QUANTITY_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/Quantity/Delete?id="+id).pipe(
        map(data=>{
          return data as QUANTITY_Interface
        })
      )
  }

  DomainQUANTITY(id:number):Observable<QUANTITY_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/Quantity/Doamin?id="+id).pipe(
        map(data=>{
          return data as QUANTITY_Interface
        })
      )
  }


  GetController(id:number):Observable<Array<Person_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Quantity/GetController?id="+id).pipe(
      map(data=>{
        return data as Array<Person_Interface>
      })
    )
  }

  PostController(
    quantity_id: number,
    persone_id: number): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      token: '',
      quantity_id: quantity_id,
      persone_id: persone_id,
    }


    return this.http.post(environment.BaseUrl + "Daro/Quantity/PostController", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  DeleteController(id:number):Observable<QUANTITY_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/Quantity/DeleteController?id=" + id
      ).pipe(
      map(data=>{
        return data as QUANTITY_Interface
      })
    )
}

}
